import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-miterlimit": "10",
  "stroke-width": "1.5",
  d: "M22 16v4.4c0 .9-.7 1.6-1.6 1.6H16M16 2h4.4c.9 0 1.6.7 1.6 1.6V8M8 22H3.6c-.9 0-1.6-.7-1.6-1.6V16M2 8V3.6C2 2.7 2.7 2 3.6 2H8"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }